<template>
  <div class="card card-custom gutter-b">
    <!--begin::Body-->
    <div class="card-body d-flex flex-column p-0">
      <div
        class="datatable datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded"
      >
        <v-data-table
          :height="tableHeight"
          :headers="translatedColumns"
          fixed-header
          :items="getItems"
          item-key="source"
          :server-items-length="pagesAmount * rowsAmount"
          hide-default-footer
          :options.sync="options"
          :page.sync="page"
          :loading="loading"
          class="text-no-wrap"
        >
          <template v-slot:top="">
            <v-item-group class="datatable-custom-header">
              <v-container fluid>
                <div class="d-flex flex-row">
                  <div class="d-flex mx-3 align-center">
                    <v-select
                      v-model="options.itemsPerPage"
                      :items="rows"
                      append-icon="mdi-chevron-down"
                      @change="getTableData()"
                    />
                  </div>
                  <Pagination
                    :page="options.page"
                    :pages-amount="pagesAmount"
                    v-on:pagechange="options.page = $event"
                  />
                  <div class="d-flex mx-auto table-title">
                    {{ tableName }}
                  </div>
                </div>
              </v-container>
            </v-item-group>
          </template>
          <template v-slot:item.status_id="{ item }">
            <span :class="getStatusClass(item.status_id)" text-color="white">{{
              item.statusText
            }}</span>
          </template>
          <template v-slot:item.name="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <span class="item-source" v-bind="attrs" v-on="on">
                  {{ cutSource(item.name) }}
                </span>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </template>
          <template v-slot:item.extension="{ item }">
            <span class="flaticon2-crisp-icons"></span>&nbsp;{{
              item.extension.toUpperCase()
            }}
          </template>
          <template v-slot:item.size="{ item }">
            <span v-if="item.size">{{ prettySize(item.size) }}</span>
            <span v-else>
              --
            </span>
          </template>
          <template v-slot:item.domains="{ item }">
            <span v-if="item.domains.length > 1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ item.domains.length }} domains
                  </span>
                </template>
                <span>{{ item.domains.join(", ") }}</span>
              </v-tooltip>
            </span>
            <span v-else>
              {{ item.domains[0] }}
            </span>
          </template>
          <template v-slot:item.downloadLink="{ item }">
            <a
              :href="item.downloadLink"
              target="_blank"
              v-if="item.downloadLink"
            >
              {{ $t("Download") }}
            </a>
            <span v-else>
              {{ $t("Download") }}
            </span>
          </template>
        </v-data-table>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
import Pagination from "@/components/_Tables/Pagination";

export default {
  name: "FilesTable",
  components: { Pagination },
  props: {
    dates: {
      type: Array,
      required: true
    },
    selectedDomains: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      tableName: null,
      gclidDialog: false,
      detailsDialog: false,
      historyDialog: false,
      historyData: null,
      row: {},
      loading: false,
      loadingClid: false,
      searchQuery: "",
      searchColumn: null,
      rowsAmount: 10,
      sortColumn: null,
      sortDirection: null,
      excelUrl: "",
      page: 1,
      pagesAmount: 1,
      searchColumns: [],
      selectedColumns: [],
      availableColumns: [],
      translationColumns: [],
      sortableColumns: [],
      table: null,
      rows: [10, 25, 50, 100],
      timestamp: 0,
      options: {},
      clicksIds: []
    };
  },
  computed: {
    tableHeight() {
      if (this.table && this.table.length > 10) return "550";
      return "auto";
    },
    icon() {
      if (!this.table) return "";
      if (this.availableColumns.length === this.selectedColumns.length)
        return "mdi-checkbox-marked";
      if (this.availableColumns.length !== this.selectedColumns.length)
        return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    dropdownColumns() {
      let columns = [];
      this.availableColumns.forEach(key => {
        columns.push({
          text: this.translationColumns[key],
          value: key
        });
      });
      return columns;
    },
    translatedColumns() {
      let columns = [];
      this.selectedColumns.forEach(key => {
        columns.push({
          text: this.translationColumns[key],
          value: key,
          sortable: this.sortableColumns.includes(key)
        });
      });
      columns = columns?.filter(el => el.value != "statusText");
      return columns;
    },
    getItems() {
      return this.table || [];
    }
  },
  watch: {
    options: {
      async handler() {
        await this.getTableData();
      }
    },
    async dates() {
      await this.getTableData();
    },
    async selectedDomains() {
      await this.getTableData();
    }
  },
  methods: {
    cutSource(source) {
      if (source.length > 50) {
        source = source.substr(0, 50) + "...";
      }
      return source;
    },
    prettySize(digit) {
      let k = 0;
      let suffix = "b";
      while (digit / 1024 > 1) {
        digit = Math.round(digit / 1024);
        k++;
      }

      switch (k) {
        case 1:
          suffix = "Kb";
          break;

        case 2:
          suffix = "Mb";
          break;

        case 3:
          suffix = "Gb";
          break;
      }

      return digit + suffix;
    },
    getStatusClass(statusId) {
      switch (statusId) {
        case 0:
          return "test-grey";
        case 1:
          return "test-green";
        case -1:
          return "test-red";
        default:
          return "";
      }
    },
    async getTableData() {
      this.loading = true;
      if (!this.page) {
        this.page = 1;
      }
      try {
        const {
          pagesAmount,
          searchColumns,
          visibleColumns,
          availableColumns,
          translations,
          sortableColumns,
          table,
          timestamp,
          name
        } = await this.$api.user.getFilesList({
          dateFrom: this.dates[0],
          dateTo: this.dates[1] ?? this.dates[0],
          domains: this.selectedDomains.map(el => el.id),
          searchQuery: this.searchQuery,
          rowsAmount: this.options.itemsPerPage,
          searchColumn: this.searchColumn,
          selectedColumns: this.selectedColumns,
          page: this.options.page,
          sortColumn: this.options.sortBy[0],
          sortDirection:
            this.options.sortDesc[0] === false
              ? "asc"
              : this.options.sortDesc[0] === true
              ? "desc"
              : null,
          tableName: "fileList"
        });
        if (timestamp > this.timestamp) {
          this.pagesAmount = pagesAmount;
          this.searchColumns = searchColumns;
          this.selectedColumns = visibleColumns;
          this.availableColumns = availableColumns;
          this.translationColumns = translations;
          this.sortableColumns = sortableColumns;
          this.table = table;
          this.timestamp = timestamp;
          this.tableName = name;
        }
      } catch (e) {
        switch (e.response.status) {
          case 401: {
            await this.$api.auth.logout();
          }
        }
      } finally {
        this.loading = false;
      }
    },
    async selectAllColumns() {
      if (this.selectedColumns.length === this.availableColumns.length) {
        this.selectedColumns = [];
      } else {
        this.selectedColumns = this.availableColumns;
      }
      await this.getTableData();
    },
    async setSorting(columnName) {
      if (columnName !== this.sortColumn) {
        this.sortColumn = columnName;
        this.sortDirection = null;
      }
      if (this.sortDirection) {
        if (this.sortDirection === "desc") {
          this.sortDirection = "asc";
        } else {
          this.sortColumn = null;
          this.sortDirection = null;
        }
      } else {
        this.sortDirection = "desc";
      }
      await this.getTableData();
    }
  }
};
</script>

<style>
.v-progress-linear__background {
  background: #1867c0 !important;
}
.v-progress-linear__indeterminate {
  background: #1867c0 !important;
}
.table-title {
  color: white;
  font-size: 1.75rem;
  line-height: 3rem;
  text-align: center;
}
</style>
